import {FxRateHistory} from '../../model/admin/fxratehistory';
import {BaseResponse} from '../internal/baseresponse';
export class ADMFxRateHistoryResult extends BaseResponse {
  data: Array<FxRateHistory>;
}



// WEBPACK FOOTER //
// ./src/app/response/admin/admfxratehistoryresult.ts